import { Routes } from '@angular/router';
import { NotfoundComponent } from './pages/notfound/notfound.component';
import { SettingsComponent } from './pages/settings/settings.component';
import { authGuard } from './core/interceptors/auth.guard';
import { SupportComponent } from './pages/support/support.component';
import { UsersComponent } from './pages/settings/user/user-list/user-list.component';
import { ElectionListComponent } from './pages/election/election-list/election-list.component';
import { MainElectionComponent } from './layout/main-election/main-election.component';
import { MainAdminComponent } from './layout/main-admin/main-admin.component';
import { NewElectionComponent } from './pages/election/new-election/new-election.component';
import { unsavedChangesGuard } from './core/guards/unsaved-changes.guard';

export const routes: Routes = [
        { path: '',
          component: MainAdminComponent,
          children: [
            { path: '', 
              component: ElectionListComponent,
              canActivate: [authGuard],
              data: { roles: ['ROLE_ADMIN', 'ROLE_USER', 'ROLE_SYS_ADMIN'] } },
            { path: 'election/new',
              component: NewElectionComponent,
              canActivate: [authGuard],
              canDeactivate: [unsavedChangesGuard],
              data: { roles: ['ROLE_ADMIN', 'ROLE_SYS_ADMIN'] } },
            { path: 'settings', 
              component: SettingsComponent,
              canActivate: [authGuard],
              data: { roles: ['ROLE_SYS_ADMIN'] } },
            { path: 'support', 
              component: SupportComponent,
              canActivate: [authGuard],
              data: { roles: ['ROLE_SYS_ADMIN'] } },
            { path: 'users', 
              component: UsersComponent,
              canActivate: [authGuard],
              data: { roles: ['ROLE_ADMIN', 'ROLE_SYS_ADMIN'] } }]}, 
  { path: '',
          component: MainElectionComponent,
          children: [
             
            { path: 'election', 
              loadChildren: () => import('./pages/election/election.routes'),
              canActivate: [authGuard],
              data: { roles: ['ROLE_ADMIN', 'ROLE_USER', 'ROLE_SYS_ADMIN'] } },  
            { path: 'election/configuration', 
              loadChildren: () => import('./pages/election/file-config/file-config.routes'),
              canActivate: [authGuard],
              data: { roles: ['ROLE_ADMIN', 'ROLE_USER', 'ROLE_SYS_ADMIN'] } },   
            { path: 'election/groups', 
              loadChildren: () => import('./pages/election/group/group.routes'),
              canActivate: [authGuard],
              data: { roles: ['ROLE_ADMIN', 'ROLE_USER', 'ROLE_SYS_ADMIN'] } },                 
            { path: 'election/report', 
              loadChildren: () => import('./pages/election/table-report/report.routes'),
              canActivate: [authGuard],
              data: { roles: ['ROLE_ADMIN', 'ROLE_USER', 'ROLE_SYS_ADMIN'] } },                 
            { path: 'upload', 
              loadChildren: () => import('./pages/election/file-upload/file-upload.routes'),
              canActivate: [authGuard],
              data: { roles: ['ROLE_ADMIN', 'ROLE_USER', 'ROLE_SYS_ADMIN'] } },               
        ]
    },
        { path: 'auth', loadChildren: () => import('./pages/auth/auth.routes') },
        { path: 'notfound', component: NotfoundComponent },
        { path: '**', redirectTo: '/notfound' }
];
